<template>
    <framed-layout>

        <template #center>
            <h3 class="font-bold">Koosta meeskond</h3>
        </template>

        <template #right>
            <router-link :to="'/project/' + projectUserId" class="btn-circle">
                <i class="text-xl text-blue-500 pi pi-times"></i>
            </router-link>
        </template>

        <Dialog :visible.sync="showModal" :closable="true" :dismissableMask="true" modal class="w-2/3">
          <profile :member-id="this.memberId"/>
        </Dialog>

        <div class="max-w-xl mx-auto mb-6">
          <p>
            Vali igasse valdkonda vähemalt üks projekteerija.
            Kui kõik meeskonnaliikmed on oma ülesanded täpsustanud, saad kogu meeskonna kinnitada.
          </p>
        </div>

        <div v-if="can_form_team" class="flex flex-col items-center mb-6">
          <button ref="confirmTeamButton" @click="confirmTeam" class="w-full text-white bg-blue-500 uppercase btn xs:w-72">
            Kinnita meeskond
          </button>
        </div>

        <div class="max-w-xl mx-auto">
            <div v-for="a in areas" :key="a.area.id" class="mb-6 md:mb-12">
                <h2 class="font-semibold leading-tight text-black text-2xl md:text-4xl">{{ a.area.name }}</h2>
                <p v-if="AreaType.PRIMARY === a.area.areaType.id">Süsteemi poolt välja pakutud
                    <span class="text-blue-500">hind {{ a.cost }} €</span>
                </p>

                <accordion :multiple="true" :activeIndex="[0, 1]" class="my-3 rounded-lg shadow-xl">
                  <accordion-tab class="rounded-lg shadow-xl bg-white">
                    <template #header>
                      <span v-if="AreaType.PRIMARY === a.area.areaType.id">Vastutav</span>
                      <span v-else>Spetsialist</span>
                    </template>

                    <div class="my-8">
                      <div
                          v-for="person in team[a.area.id].leads"
                          :key="person.name"
                          class="flex items-center flex-wrap justify-between py-4 px-4 md:px-8 my-3 rounded-lg shadow-xl bg-white">
                        <div class="flex items-center">
                          <div
                              :style="'background: url(' + person.profile_photo_url + ') no-repeat center center; background-size: cover;'"
                              class="w-12 h-12 mr-4 bg-gray-300 rounded-full"
                              :class="person.available ? '' : 'p-disabled'"
                              v-badge="person.rating"
                          >
                            <div
                                v-if="false"
                                :class="person.available ? 'bg-green-500' : 'bg-red-600'"
                                class="absolute bottom-0 right-0 rounded-full w-3 h-3 border-2 border-white"
                            ></div>
                          </div>

                          <div :class="person.available ? '' : 'p-disabled'">
                            <h3 class="font-semibold text-gray-900">{{ person.name }}</h3>
                            <h4 class="text-xs text-gray-600">Pakkumine {{ person.price }}€</h4>
                          </div>
                        </div>

                        <div class="w-full xs:w-auto flex flex-col items-end text-right mt-2 sm:mt-0">
                          <button
                              v-if="person.selected && person.id !== user.id"
                              @click="removeTeamMember(person.projectUserId)"
                              class="bg-orange-200 btn-sm rounded-full uppercase text-xs"
                              :class="person.available ? '' : 'p-disabled'"
                          >
                            Eemalda
                          </button>

                          <button
                              @click="addTeamMember(person.projectUserId)"
                              v-else-if="!person.selected && person.id !== user.id"
                              class="bg-blue-300 btn-sm rounded-full uppercase text-xs"
                              :class="person.available ? '' : 'p-disabled'"
                          >
                            Vali
                          </button>

                          <div class="text-blue-500 text-xs mt-2 cursor-pointer" @click="showProfile(person.id)">
                            Vaata profiili
                          </div>
                        </div>
                      </div>
                    </div>

                    <button
                        @click="addSpecialist(a.area, true)"
                        class="mt-5 text-orange-400 bg-orange-200 btn-sm rounded-full">
                      <span class="mr-3 text-xs font-bold pi pi-plus"></span>
                      <span v-if="AreaType.PRIMARY === a.area.areaType.id">Kutsu uus vastutav</span>
                      <span v-else>Kutsu uus spetsialist</span>
                    </button>
                  </accordion-tab>
                  <accordion-tab v-if="AreaType.PRIMARY === a.area.areaType.id" header="Tehnik" class="rounded-lg shadow-xl bg-white">
                    <div class="my-8">
                      <div
                          v-for="person in team[a.area.id].nonLeads"
                          :key="person.name"
                          class="flex items-center flex-wrap justify-between py-4 px-4 md:px-8 my-3 rounded-lg shadow-xl bg-white">
                        <div class="flex items-center">
                          <div
                              :style="'background: url(' + person.profile_photo_url + ') no-repeat center center; background-size: cover;'"
                              class="w-12 h-12 mr-4 bg-gray-300 rounded-full"
                              :class="person.available ? '' : 'p-disabled'"
                              v-badge="person.rating"
                          >
                            <div
                                v-if="false"
                                :class="person.available ? 'bg-green-500' : 'bg-red-600'"
                                class="absolute bottom-0 right-0 rounded-full w-3 h-3 border-2 border-white"
                            ></div>
                          </div>

                          <div :class="person.available ? '' : 'p-disabled'">
                            <h3 class="font-semibold text-gray-900">{{ person.name }}</h3>
                            <h4 class="text-xs text-gray-600">Pakkumine {{ person.price }}€</h4>
                          </div>
                        </div>

                        <div class="w-full xs:w-auto flex flex-col items-end text-right mt-2 sm:mt-0">
                          <button
                              v-if="person.selected"
                              @click="removeTeamMember(person.projectUserId)"
                              class="bg-orange-200 btn-sm rounded-full uppercase text-xs"
                              :class="person.available ? '' : 'p-disabled'"
                          >
                            Eemalda
                          </button>

                          <button
                              v-else
                              @click="addTeamMember(person.projectUserId)"
                              class="bg-blue-300 btn-sm rounded-full uppercase text-xs"
                              :class="person.available ? '' : 'p-disabled'"
                          >
                            Vali
                          </button>

                          <div class="text-blue-500 text-xs mt-2 cursor-pointer" @click="showProfile(person.id)">
                            Vaata profiili
                          </div>
                        </div>
                      </div>
                    </div>

                    <button
                        @click="addSpecialist(a.area, false)"
                        class="mt-5 text-orange-400 bg-orange-200 btn-sm rounded-full"
                    >
                      <span class="mr-3 text-xs font-bold pi pi-plus"></span>
                      Kutsu uus tehnik
                    </button>
                  </accordion-tab>
                </accordion>

            </div>
        </div>
    </framed-layout>
</template>

<script>
import FramedLayout from './../Layouts/FramedLayout'
import Profile from './../components/Profile';
import {getCreateTeam, addMember, removeMember, confirmTeam} from '../store/team.api';
import {mapGetters} from "vuex";
import {AreaType} from "../utils/area.type";

export default {
    components: {
      Profile,
      FramedLayout
    },
    metaInfo: {
      title: 'Koosta meeskond',
      meta: [
        { property: 'og:title', content: 'Koosta meeskond' },
        { name: 'description', content: 'Projekteerimise meeskonna moodustab parim võimalik kvalifitseeritud ekspertide valim' },
        { name: 'keywords', content: 'Tellija, projektijuht, projekteerija, projekteerimine, meeskond, projekt, kvalifikatsioon, reiting' },
        { property: 'robots', content: 'index, nofollow' },
      ]
    },
    computed: {
      ...mapGetters({
        user: 'global/user',
      }),
      AreaType() {
        return AreaType;
      }
    },
    data() {
        return {
          projectUserId: null,
          areas: [],
          team: [],
          can_form_team: false,
          showModal: false,
          memberId: null,
          isLead: null,
        }
    },
    methods: {
        showProfile(memberId) {
          this.memberId = memberId;
          this.showModal = true;
          window.scrollTo(0,0);
        },
        confirmTeam() {
            this.$refs.confirmTeamButton.classList.add('p-disabled');
            confirmTeam(this.projectUserId).then(({data}) => {
                this.$refs.confirmTeamButton.classList.remove('p-disabled');
                setTimeout(() => {
                    this.processAxiosPositiveResponse(data)
                }, 100);
                this.$router.go(-1);
            }, (error) => {
              this.$refs.confirmTeamButton.classList.remove('p-disabled');
              const toast = error.response?.data;
              if (toast) {
                this.processAxiosPositiveResponse(toast);
              } else {
                this.showToast('Meeskonna kinnitamine ebaõnnestus', 'error');
              }
            });
        },
        async removeTeamMember(projectUserId) {
            const params = {
                projectUserId: projectUserId,
            };
            await removeMember(this.projectUserId, params).then(({data}) => this.processAxiosPositiveResponse(data));
            await this.getData()
        },
        async addTeamMember(projectUserId) {
            const params = {
                projectUserId: projectUserId,
            };
            await addMember(this.projectUserId, params).then(({data}) => this.processAxiosPositiveResponse(data));
            await this.getData()
        },
        async addSpecialist(area, isLead) {
            this.$router.push({
              path: `/project/${this.projectUserId}/add-specialist`,
              query: {
                areaId: area.id,
                isLead: isLead
              },
            });
        },
        async getData() {
            const { data } = await getCreateTeam(this.$route.params.projectUserId);
            if (data) {
                this.team = data?.team;
                this.areas = data?.areas;
                this.can_form_team = data?.can_form_team;
            }
        },
    },
    mounted() {
        this.projectUserId = this.$route.params.projectUserId;

        this.getData();
    }
}
</script>
<style>
.p-accordion .p-accordion-content {
  background: none;
}
</style>